import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { MultiSelectCombobox } from '../../../legacy-design-system/combobox'

interface Library {
  readonly library_name: string
  readonly sha1: string
}

function Wrapper({ values, items, placeHolderText, disabled, onChange }) {
  if (!Array.isArray(values)) {
    throw new Error('values is required')
  }

  if (!Array.isArray(items)) {
    throw new Error('items is required')
  }

  if (!onChange || typeof onChange !== 'function') {
    throw new Error('onChange is required')
  }

  return (
    <MultiSelectCombobox<Library>
      values={values}
      items={items}
      placeHolderText={placeHolderText}
      disabled={disabled}
      onChange={onChange}
      itemToString={itemToString}
      itemToID={itemToID}
    />
  )
}

function itemToString(item: Library) {
  return item.library_name
}

function itemToID(item: Library) {
  return item.sha1
}

export const librariesMultiSelectCombobox = createNgReactBridgeDirective(
  'reactLibrariesMultiSelectCombobox',
  [],
  Wrapper,
  ['values', 'items', 'placeHolderText', 'disabled', 'onChange']
)
